<template>
  <ContentContainer class="how-section" v-if="!content['how_it_works_section_is_hidden_' + langCode.value]">
    <h2 class="how-section__title" :style="[content['color'] ? {color: content['color']} : '']">
      {{ content['how_it_works_section_title_' + langCode.value] ?? '' }}
    </h2>
    <p class="how-section__description">
      {{ content['how_it_works_section_description_' + langCode.value] ?? '' }}

    </p>
    <div class="items-wrap">
      <div
          v-for="(item, index) in content.how_it_works_section_steps"
          :key="index"
          :class="`item--${index}`"
          class="item"
      >
        <div class="item__number" :style="[content['color'] ? {backgroundColor: content['color']} : '#253FDC']">
          {{ index+1 }}
        </div>
                <div class="item__info-box">

                  <h3 class="item__title" :style="[content['color'] ? {color: content['color']} : '']">
                    {{ item['title_' + langCode.value]}}
                  </h3>
                  <div class="item__title__line" :style="[content['color'] ? {backgroundColor: content['color']} : '#253FDC']"></div>

                  <p class="item__description">
                    {{ item['text_' + langCode.value]}}
                  </p>
                </div>
      </div>
    </div>
    <BaseButton
        class="how-section__btn"
        :value='content["how_it_works_section_button_text_" + langCode.value] ?? ""'
        @handleClick="scrollToForm()"
    />
  </ContentContainer>
</template>

<script setup lang="ts">
import ContentContainer from '@/layout/ContentContainer.vue'
import BaseButton from '@/components/Base/BaseButton.vue';
import {useI18n} from 'vue-i18n'
import {useStore} from "vuex";
import {ComponentInstance, computed, ref} from 'vue'

const {t} = useI18n()
const store = useStore()

const langCode = computed(() => {
  return useI18n().locale
})

const content = computed(() => {
  return store.state.pageContent
})

const scrollToForm = () => {
  document?.querySelector('.form')?.scrollIntoView({behavior: "smooth"})
}


</script>

<style lang="scss" scoped>

</style>
